import { graphql } from '../../gql';

/**
 * The triage list pane. Deliberately narrow: enough to choose the next order
 * to work, and nothing that would make the pane scroll sideways.
 */
export const TRIAGE_ORDERS_QUERY = graphql(`
  query TriageOrders($filter: String, $first: Int, $sellerOrderStatus: [SellerOrderStatus!]) {
    sellerOrderConnection(filter: $filter, first: $first, sellerOrderStatus: $sellerOrderStatus) {
      count
      edges {
        node {
          id
          idAlias
          orderDate
          total
          status
          customer {
            firstName
            lastName
          }
          items {
            title
            quantity
            shippingPrice
            productThumbnail
            featuredImage {
              thumbnailUrl
              altText
            }
          }
        }
      }
    }
  }
`);
